export default
`
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.9375 14.25V16H8.3125V14.25C8.3125 13.0469 7.32812 12.0625 6.125 12.0625C4.89453 12.0625 3.9375 13.0469 3.9375 14.25ZM2.625 16V14.25C2.625 12.3359 4.18359 10.75 6.125 10.75C8.03906 10.75 9.625 12.3359 9.625 14.25V16H10.5C11.457 16 12.25 16.793 12.25 17.75V23C12.25 23.9844 11.457 24.75 10.5 24.75H1.75C0.765625 24.75 0 23.9844 0 23V17.75C0 16.793 0.765625 16 1.75 16H2.625ZM1.3125 17.75V23C1.3125 23.2461 1.50391 23.4375 1.75 23.4375H10.5C10.7188 23.4375 10.9375 23.2461 10.9375 23V17.75C10.9375 17.5312 10.7188 17.3125 10.5 17.3125H1.75C1.50391 17.3125 1.3125 17.5312 1.3125 17.75Z"
    fill="currentColor"
    transform="translate(6.7 -1.5) scale(0.75)"
  />
</svg>
`